// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page.page-1 .searchbar {
  /*
  --background	Background of the searchbar
  --cancel-button-color	Color of the searchbar cancel button
  --clear-button-color	Color of the searchbar clear button
  --color	Color of the searchbar text
  --icon-color	Color of the searchbar icon
  --placeholder-color	Color of the searchbar placeholder
  --placeholder-font-style	Font style of the searchbar placeholder
  --placeholder-font-weight	Font weight of the searchbar placeholder
  --placeholder-opacity	Opacity of the searchbar placeholder
  */
  border: 1px solid var(--app-mid-lighter-2);
  --border-radius: 5px;
  border-radius: 5px;
  padding: 0;
  --box-shadow: none;
}

.page.page-2 .input-field-wrap .input-field, .page.page-2 .input-fields.input-fields--text .input-field, .page.page-3 .input-email .input-field {
  border: 1px solid var(--app-mid-lighter-2);
  border-radius: 5px;
  --padding-start: 8px;
  --padding-end: 8px;
}

.pg-footer {
  border-top: 1px solid var(--app-mid-lighter-2);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
}
.pg-footer .foot-btn {
  margin: 0;
  font-weight: 600;
}
.pg-footer .foot-btn.mw-120 {
  min-width: 120px;
}
.pg-footer::before {
  content: normal;
}

.pg-header {
  padding: 15px 20px;
  background-color: var(--app-main-darker);
}
.pg-header .head-elem.he-title {
  margin-bottom: 20px;
}
.pg-header .head-elem.he-title.mb-0 {
  margin-bottom: 0;
}
.p-20.pg-header {
  padding: 20px 20px;
}

.page.page-3 .emails .email .text, .page.page-4, .page.page-5, .page.page-4 .output-val, .page.page-5 .output-val {
  word-break: break-all;
  word-break: break-word;
}

.page.page-2 .ri-field .rif-text-wrap .rif-text {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.ion-activatable {
  position: relative;
}
.ion-activatable.ripple-bounded {
  overflow: hidden;
}
.ion-activatable > ion-ripple-effect.ripple {
  /*&.main-soft {
    color: var(--app-main-soft);
  }*/
}
.ion-activatable > ion-ripple-effect.ripple.contr {
  color: var(--app-contr);
}
.ion-activatable > ion-ripple-effect.ripple.darkest {
  color: var(--app-darkest);
}
.ion-activatable > ion-ripple-effect.ripple.lightest {
  color: var(--app-lightest);
}
.ion-activatable > ion-ripple-effect.ripple.main {
  color: var(--app-main);
}
.ion-activatable > ion-ripple-effect.ripple.main-darker {
  color: var(--app-main-darker);
}
.ion-activatable > ion-ripple-effect.ripple.main-softer {
  color: var(--app-main-softer);
}
.ion-activatable > ion-ripple-effect.ripple.main-strong {
  color: var(--app-main-strong);
}
.ion-activatable > ion-ripple-effect.ripple.mid-light {
  color: var(--app-mid-light);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter {
  color: var(--app-mid-lighter);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter-2 {
  color: var(--app-mid-lighter-2);
}

.page {
  padding: 20px 20px 50px;
}
.page .input-lbl {
  margin-bottom: 15px;
  color: var(--app-mid);
  font-size: 18px;
  font-weight: 500;
}
.page.page-1 .cars {
  padding-top: 15px;
}
.page.page-1 .searchbar {
  max-width: 350px;
}
.page.page-2 .info-timezone {
  grid-column: 1/-1;
  margin-bottom: 16px;
}
.page.page-2 .info-timezone a {
  padding-left: 20px;
  font-size: 14px;
  cursor: pointer;
  color: var(--app-main);
}
.page.page-2 .ri-field {
  width: 100%;
  border: 1px solid var(--app-mid-lighter-2);
  border-radius: 5px;
  padding: 10px 15px;
  background-color: var(--app-base);
  cursor: pointer;
  max-width: 100%;
}
.page.page-2 .ri-field .rif-text-wrap .rif-text.rif-text-no-val {
  color: var(--app-mid-lighter);
}
.page.page-2 .ri-field .rif-text-wrap .rif-text.rif-text-val {
  color: var(--app-mid-dark);
  text-align: center;
}
.page.page-2 .output-lbl {
  color: var(--app-mid-dark);
  margin-bottom: 20px;
  font-size: 17px;
  font-weight: 500;
}
.page.page-2 .input-field-wrap {
  display: flex;
  align-items: center;
}
.page.page-2 .input-field-wrap .input-field {
  max-width: 300px;
}
.page.page-2 .input-field-wrap .input-unit {
  margin-left: 12px;
  color: rgba(var(--app-mid-rgb), 0.7);
  font-size: 14px;
  font-weight: 500;
}
.page.page-2 .input-field-wrap:not(:last-child) {
  margin-bottom: 20px;
}
.page.page-2 .input-fields {
  display: flex;
  flex-wrap: wrap;
}
.page.page-2 .input-fields.input-fields--check {
  margin: -8px -10px 0;
}
.page.page-2 .input-fields.input-fields--check .input-field.special {
  margin-left: 15px;
}
.page.page-2 .input-fields.input-fields--text {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(auto, 250px));
  gap: 10px 30px;
}
.page.page-2 .input-fields.input-fields--time {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(auto, 250px));
  gap: unset;
}
.page.page-2 .input-fields.input-fields--time ngx-timepicker-field.ri-field {
  width: 210px !important;
  padding-bottom: 2px !important;
  padding-top: 4px !important;
}
.page.page-2 .input-fields.input-fields--time ngx-timepicker-field .input-fields.input-fields--text {
  gap: unset !important;
}
.page.page-2 .input-fields.input-fields--toggle {
  margin: -10px -20px 0;
}
.page.page-2 .input-fields:not(:last-child) {
  margin-bottom: 20px;
}
.page.page-3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, auto));
  gap: 25px 40px;
}
.page.page-3 .col-bordered {
  border-right: 1px solid var(--app-mid-lighter-2);
}
.page.page-3 .info-lang {
  grid-column: 1/-1;
}
.page.page-3 .info-lang a {
  padding-left: 30px;
  font-size: 14px;
  cursor: pointer;
  color: var(--app-main);
}
.page.page-3 .input-email {
  display: flex;
  align-items: center;
}
.page.page-3 .input-email .input-field {
  margin-right: 12px;
}
.page.page-3 .input-email .btn-add {
  margin: 0;
  --border-radius: 50%;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 8px;
  --padding-end: 8px;
  height: auto;
  font-size: 9px;
}
.page.page-3 .emails {
  padding-top: 10px;
}
.page.page-3 .emails ion-chip {
  max-width: 90%;
}
.page.page-3 .emails ion-chip ion-label {
  max-width: calc(100% - 24px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.page.page-3 .emails .email {
  display: flex;
  align-items: center;
}
.page.page-3 .emails .email .text {
  margin-top: -1px;
  margin-right: 15px;
  color: var(--app-mid-dark);
  font-size: 17px;
  line-height: 20px;
  font-weight: 500;
  max-height: calc(2 * 20px);
  overflow-y: hidden;
}
.page.page-3 .emails .email .btn-close {
  margin: 0;
  --border-radius: 50%;
  --padding-top: 5px;
  --padding-bottom: 5px;
  --padding-start: 5px;
  --padding-end: 5px;
  height: auto;
}
.page.page-3 .push-list {
  margin: -8px -5px;
  padding-top: 5px;
}
.page.page-3 .push-list .select-all {
  margin-bottom: 7px;
}
.page.page-3 .push-list ion-chip {
  max-width: 90%;
}
.page.page-3 .push-list ion-chip ion-label {
  max-width: calc(100% - 48px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.page.page-4, .page.page-5 {
  padding-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, auto));
  gap: 12px 25px;
  justify-content: center;
}
.page.page-4 .input-lbl, .page.page-5 .input-lbl {
  grid-column: 1/3;
  margin-bottom: 8px;
}
.page.page-4 .output-lbl, .page.page-5 .output-lbl {
  color: var(--app-mid-light);
  font-size: 17px;
  font-weight: 500;
}
.page.page-4 .output-val, .page.page-5 .output-val {
  color: var(--app-mid-dark);
  font-size: 17px;
  font-weight: 500;
}
.page.page-4 .output-val a, .page.page-5 .output-val a {
  cursor: pointer;
  margin: 0 5px;
}
.page.page-4 .output-val a.und_ln, .page.page-5 .output-val a.und_ln {
  text-decoration: underline;
}
.page.page-4 .u-btn, .page.page-5 .u-btn {
  margin: 0;
  margin-left: 15px;
  font-weight: 600;
  text-transform: none;
}

.no_email {
  color: var(--app-mid-light);
}

ion-input {
  --padding-top: 12px;
  --padding-bottom: 12px;
  --padding-start: 12px;
  --padding-end: 12px;
}

.subtitle {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 30px;
  padding: 20px;
  margin-bottom: 20px;
  font-size: 0.9rem;
}
.subtitle span {
  line-height: 28px;
  font-weight: 400;
  color: var(--app-mid);
}
.subtitle img {
  height: 35px;
  width: 35px;
}`, "",{"version":3,"sources":["webpack://./src/theme/desktop/desktop.scss","webpack://./src/app/pages/desktop/common/report-settings/report-settings.page.scss","webpack://./src/theme/desktop/modal_alarm.scss"],"names":[],"mappings":"AAqIA;EACE;;;;;;;;;;GAAA;EAYA,0CAhJc;EAkJd,oBAAA;EACA,kBAlJa;EAoJb,UAAA;EAEA,kBAAA;ACxIF;;AD4JA;EAYE,0CAvLc;EAwLd,kBAAA;EAIC,oBAAA;EACD,kBAAA;ACvKF;;ADuLA;EACE,8CA9Mc;EA+Mf,kBAAA;EAEA,aAAA;EACA,8BAAA;ACrLD;ADuLC;EACC,SAAA;EACE,gBAAA;ACrLJ;ADyLI;EACE,gBAAA;ACvLN;AD2LC;EACC,eAAA;ACzLF;;AD6LA;EACE,kBAAA;EACA,wCAAA;AC1LF;AD6LI;EACE,mBAAA;AC3LN;AD6LM;EACE,gBAAA;AC3LR;ADgME;EACE,kBAAA;AC9LJ;;ADqMA;EACE,qBAAA;EAEA,sBAAA;ACnMF;;ADsMA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;ACnMF;;AD6NA;EACE,kBAAA;AC1NF;AD4NE;EACE,gBAAA;AC1NJ;AD8NE;EAwBE;;IAAA;ACjPJ;AD2NI;EACE,uBAAA;ACzNN;AD6NI;EACE,yBAAA;AC3NN;AD8NI;EACE,0BAAA;AC5NN;ADgOI;EACE,sBAAA;AC9NN;ADiOI;EACE,6BAAA;AC/NN;ADsOI;EACE,6BAAA;ACpON;ADuOI;EACE,6BAAA;ACrON;ADyOI;EACE,2BAAA;ACvON;AD0OI;EACE,6BAAA;ACxON;AD2OI;EACE,+BAAA;ACzON;;AC3FA;EACC,uBFmBQ;AC2ET;ACzFC;EACC,mBAAA;EAEA,qBAAA;EACA,eAAA;EACA,gBAAA;AD0FF;ACpFE;EACC,iBAAA;ADsFH;AClFE;EAEC,gBAAA;ADmFH;AC1EI;EACE,iBAAA;EACA,mBAAA;AD4EN;AC1EM;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AD4ER;ACrEI;EACE,WAAA;EACA,0CFjEU;EEkEV,kBFjES;EEmET,kBAAA;EACA,iCAAA;EAEA,eAAA;EAGA,eAAA;ADmEN;AC1DU;EACE,6BAAA;AD4DZ;AC1DU;EACE,0BAAA;EACA,kBAAA;AD4DZ;ACnDI;EACE,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ADqDN;AChDE;EACC,aAAA;EACA,mBAAA;ADkDH;AChDG;EAEC,gBAAA;ADiDJ;AC9CG;EACC,iBAAA;EAEA,oCAAA;EAEA,eAAA;EACA,gBAAA;AD8CJ;AC3CG;EACC,mBA3GE;ADwJN;ACxCE;EACC,aAAA;EACA,eAAA;AD0CH;ACvCG;EACC,oBAAA;ADyCJ;ACtCK;EACC,iBAAA;ADwCN;ACjCG;EACC,aAAA;EACA,6DAAA;EACA,cAAA;ADmCJ;ACNY;EAWE,aAAA;EACA,6DAAA;EACA,UAAA;ADFd;ACTgB;EACE,uBAAA;EACA,8BAAA;EACA,2BAAA;ADWlB;ACTgB;EACE,qBAAA;ADWlB;ACFG;EACC,qBAAA;ADIJ;ACAG;EACC,mBAxLE;AD0LN;ACMC;EACC,aAAA;EACA,4DAAA;EACA,cAAA;ADJF;ACME;EACI,gDAAA;ADJN;ACQI;EACE,iBAAA;ADNN;ACQM;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;ADNR;ACWE;EACC,aAAA;EACA,mBAAA;ADTH;ACWG;EAEC,kBAAA;ADVJ;ACaG;EACC,SAAA;EACA,oBAAA;EAGA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;EAEA,cAAA;ADfJ;ACqBE;EACC,iBAAA;ADnBH;ACsBM;EACE,cAAA;ADpBR;ACqBQ;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADnBV;ACyBG;EACC,aAAA;EACA,mBAAA;ADvBJ;ACyBI;EACC,gBAAA;EACA,kBAAA;EAEA,0BAAA;EAGA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,0BAAA;EACA,kBAAA;AD3BL;ACiCI;EACC,SAAA;EACA,oBAAA;EAGA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;ADlCL;AC4CE;EACI,iBAAA;EACH,gBAAA;AD1CH;AC4CG;EACC,kBAAA;AD1CJ;AC8CM;EACE,cAAA;AD5CR;AC6CQ;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AD3CV;ACqDC;EACC,iBAAA;EAEA,aAAA;EAGA,iDAAA;EACA,cAAA;EAGA,uBAAA;ADxDF;ACmEE;EACC,gBAAA;EACA,kBAAA;ADjEH;ACwEE;EACC,2BAAA;EACA,eALI;EAMJ,gBALI;ADjEP;AC0EE;EACC,0BAAA;EACA,eAZI;EAaJ,gBAZI;AD5DP;AC4EY;EACE,eAAA;EACA,aAAA;AD1Ed;AC4Ec;EACE,0BAAA;AD1EhB;ACgFQ;EACE,SAAA;EACA,iBAAA;EAEA,gBAAA;EACA,oBAAA;AD/EV;;ACgGA;EACE,2BAAA;AD7FF;;ACiGA;EACE,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AD9FF;;AA7UA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EAEA,mBAAA;EACA,iBAAA;AA+UF;AA7UE;EACD,iBAAA;EACA,gBAAA;EACA,qBAAA;AA+UD;AA7UE;EACD,YAAA;EACA,WAAA;AA+UD","sourcesContent":["\n\n$borderDivider: 1px solid var(--app-mid-lighter-2);\n$borderRadius: 5px;\n\n$btnShadow:\n  0 3px 1px -2px rgba(0, 0, 0, 0.2),\n  0 2px 2px 0 rgba(0, 0, 0, 0.14),\n  0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n$shadow: 0 8px 16px rgba(var(--app-cover-rgb), .15);\n$shadow-sm: 0 4px 8px rgba(var(--app-cover-rgb), .15);\n\n\n// page\n\n$page_minW: 1280px;\n$page_maxW: 1920px;\n\n\n// >media queries\n\n// large screens: 1080p, 2K, 4K\n$pageWild_w: $page_maxW;\n\n\n// >padding\n\n$page_pb50: 50px;\n$page_pb20: 20px;\n\n$page_pt20: 20px;\n$page_pt30: 30px;\n\n$page_px: 20px;\n$page_py20: 20px;\n\n$page_p: $page_pt20 $page_px $page_pb50;\n$page_p-v2: $page_pt30 $page_px $page_pb50;\n\n\n$popover_p: 10px 0;\n\n\n\n\n\n\n\n%btn {\n  margin: 0;\n  font-weight: 600;\n}\n\n%cardHead {\n  border-bottom: $borderDivider;\n  padding: 9px 12px;\n\n  color: var(--app-mid-dark);\n  // font-size: 17px;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n\n\n  /* .card-head-btns {\n    margin-left: auto;\n    padding-left: 20px;\n\n    display: flex;\n    align-items: center;\n  } */\n\n  .card-head-icon {\n    margin-right: 10px;\n    // font-size: 20px;\n    font-size: 18px;\n  }\n\n}\n\n%checkbox {\n  // --border-width: 1px;\n  --border-color: rgba(var(--app-mid-light-rgb), .8);\n  --size: 19px;\n\n  // pointer-events: none;\n}\n\n// aka 'quick actions'\n%mapHudBtns {\n  border-radius: $borderRadius;\n\n  $px: 10px;\n  padding: 7px $px;\n\n  background-color: var(--app-base);\n  display: flex;\n\n  box-shadow: $shadow;\n\n\n  .hqa-btn-wrap {\n\n    .hqa-btn {\n      margin: 0;\n      --border-radius: 50%;\n\n      --padding-top: 0;\n      --padding-bottom: 0;\n      --padding-start: 0;\n      --padding-end: 0;\n\n      height: auto;\n\n      font-size: 11px;\n\n      .btn-icon {\n        margin: 8px;\n      }\n    }\n\n\n    &:not(:last-child) {\n      margin-right: $px;\n      border-right: $borderDivider;\n      padding-right: $px;\n    }\n  }\n\n}\n\n%search {\n  /*\n  --background\tBackground of the searchbar\n  --cancel-button-color\tColor of the searchbar cancel button\n  --clear-button-color\tColor of the searchbar clear button\n  --color\tColor of the searchbar text\n  --icon-color\tColor of the searchbar icon\n  --placeholder-color\tColor of the searchbar placeholder\n  --placeholder-font-style\tFont style of the searchbar placeholder\n  --placeholder-font-weight\tFont weight of the searchbar placeholder\n  --placeholder-opacity\tOpacity of the searchbar placeholder\n  */\n\n  border: $borderDivider;\n  // fix: visual glitch\n  --border-radius: #{$borderRadius};\n  border-radius: $borderRadius;\n\n  padding: 0;\n\n  --box-shadow: none;\n}\n\n%statusCircle {\n  border-radius: 50%;\n\n  height: 10px;\n  width: 10px;\n\n  &.status-off {\n    background-color: var(--app-danger);\n  }\n  &.status-on {\n    background-color: var(--app-succ);\n  }\n}\n\n\n// input\n\n%input {\n  // --background\tBackground of the input\n  // --color\tColor of the input text\n  // --padding-bottom\tBottom padding of the input\n  // --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n  // --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n  // --padding-top\tTop padding of the input\n  // --placeholder-color\tColor of the input placeholder text\n  // --placeholder-font-style\tFont style of the input placeholder text\n  // --placeholder-font-weight\tFont weight of the input placeholder text\n  // --placeholder-opacity\tOpacity of the input placeholder text\n\n  border: $borderDivider;\n  border-radius: 5px;\n\n  // --padding-top: 10px;\n  // --padding-bottom: 10px;\n   --padding-start: 8px;\n  --padding-end: 8px;\n}\n\n%input-lg {\n  @extend %input;\n\n  $p: 12px;\n  --padding-top: #{$p};\n  --padding-bottom: #{$p};\n  --padding-start: #{$p};\n  --padding-end: #{$p};\n}\n\n\n// modal\n\n%modalFooter {\n  border-top: $borderDivider;\n\tpadding: 10px $page_px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t.foot-btn {\n\t\tmargin: 0;\n    font-weight: 600;\n\n    // .btn-icon {}\n\n    &.mw-120 {\n      min-width: 120px;\n    }\n\t}\n\n\t&::before {\n\t\tcontent: normal;\n\t}\n}\n\n%modalHeader {\n  padding: 15px $page_px;\n  background-color: var(--app-main-darker);\n\n  .head-elem {\n    &.he-title {\n      margin-bottom: 20px;\n\n      &.mb-0 {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &.p-20 {\n    padding: $page_py20 $page_px;\n  }\n}\n\n\n// text\n\n%longWord {\n  word-break: break-all;\n  // Edge 79, Firefox 67 - also: deprecated?\n  word-break: break-word;\n}\n\n%oneLiner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n\n\n\n\n\n\nion-header,\nion-content,\nion-footer {\n  //font-size: 15px;\n\n  // works but must be done on project setup\n  // some elems already in use need white-space: nowrap;\n  // @extend %longWord;\n}\n\n\n\n\n\n\n// effect\n\n.ion-activatable {\n  position: relative;\n\n  &.ripple-bounded {\n    overflow: hidden;\n  }\n\n\n  & > ion-ripple-effect.ripple {\n\n    &.contr {\n      color: var(--app-contr);\n    }\n\n\n    &.darkest {\n      color: var(--app-darkest);\n    }\n\n    &.lightest {\n      color: var(--app-lightest);\n    }\n\n\n    &.main {\n      color: var(--app-main);\n    }\n\n    &.main-darker {\n      color: var(--app-main-darker);\n    }\n\n    /*&.main-soft {\n      color: var(--app-main-soft);\n    }*/\n\n    &.main-softer {\n      color: var(--app-main-softer);\n    }\n\n    &.main-strong {\n      color: var(--app-main-strong);\n    }\n\n\n    &.mid-light {\n      color: var(--app-mid-light);\n    }\n\n    &.mid-lighter {\n      color: var(--app-mid-lighter);\n    }\n\n    &.mid-lighter-2 {\n      color: var(--app-mid-lighter-2);\n    }\n\n  }//& > ion-ripple-effect.ripple\n\n}//.ion-activatable\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","@use \"../../../../../theme/desktop/modal_alarm\" as *;\n\n\n.subtitle{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 30px;\n  padding: 20px;\n\n  margin-bottom: 20px;\n  font-size: 0.9rem;\n\n  span{\n\tline-height: 28px;\n\tfont-weight: 400;\n\tcolor: var(--app-mid);\n  }\n  img{\n\theight: 35px;\n\twidth: 35px;\n  }\n}\n","\n\n// * this is legacy use modal.scss instead\n\n\n@use \"desktop\" as *;\n@forward \"desktop\";\n\n\n\n\n\n.pg-header {\n\t@extend %modalHeader;\n}\n\n\n.page {\n\tpadding: $page_p;\n\n\t$mb: 20px;\n\n\n\t.input-lbl {\n\t\tmargin-bottom: 15px;\n\n\t\tcolor: var(--app-mid);\n\t\tfont-size: 18px;\n\t\tfont-weight: 500;\n\t}\n\n\n\t&.page-1 {\n\n\t\t.cars {\n\t\t\tpadding-top: 15px;\n\t\t\t// max-width: 350px;\n\t\t}\n\n\t\t.searchbar {\n\t\t\t@extend %search;\n\t\t\tmax-width: 350px;\n\t\t}\n\n\t}\n\n\n\t&.page-2 {\n\n    // Aggiunta Vigo\n    .info-timezone{\n      grid-column: 1/-1;\n      margin-bottom: 16px;\n\n      a{\n        padding-left: 20px;\n        font-size: 14px;\n        cursor: pointer;\n        color: var(--app-main);\n      }\n    }\n    // Fine aggiunta Vigo\n\n\n    // Aggiunto da vigo\n    .ri-field {\n      width: 100%;\n      border: $borderDivider;\n      border-radius: $borderRadius;\n\n      padding: 10px 15px;\n      background-color: var(--app-base);\n\n      cursor: pointer;\n\n      // width bug fix\n      max-width: 100%;\n\n\n      .rif-text-wrap {\n        //display: grid;\n\n        .rif-text {\n          @extend %oneLiner;\n\n          &.rif-text-no-val {\n            color: var(--app-mid-lighter);\n          }\n          &.rif-text-val {\n            color: var(--app-mid-dark);\n            text-align: center;\n          }\n\n        }//.rif-text\n      }//.rif-text-wrap\n\n    }//.ri-field\n\n    // Vigo\n    .output-lbl {\n      color: var(--app-mid-dark);\n      margin-bottom: 20px;\n      font-size: 17px;\n      font-weight: 500;\n    }\n    // fine aggiunto da vigo\n\n\n\t\t.input-field-wrap {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t.input-field {\n\t\t\t\t@extend %input;\n\t\t\t\tmax-width: 300px;\n\t\t\t}\n\n\t\t\t.input-unit {\n\t\t\t\tmargin-left: 12px;\n\n\t\t\t\tcolor: rgba(var(--app-mid-rgb), .7);\n\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-bottom: $mb;\n\t\t\t}\n\t\t}\n\n\n\t\t.input-fields {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\n\n\t\t\t&.input-fields--check {\n\t\t\t\tmargin: -8px -10px 0;\n\n\t\t\t\t.input-field {\n\t\t\t\t\t&.special {\n\t\t\t\t\t\tmargin-left: 15px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t}\n\n\n\t\t\t&.input-fields--text {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: repeat(auto-fill, minmax(auto, 250px));\n\t\t\t\tgap: 10px 30px;\n\n\t\t\t\t.input-field {\n\t\t\t\t\t// &.input-field--text {\n\n\t\t\t\t\t// --background\tBackground of the input\n\t\t\t\t\t// --color\tColor of the input text\n\t\t\t\t\t// --padding-bottom\tBottom padding of the input\n\t\t\t\t\t// --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n\t\t\t\t\t// --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n\t\t\t\t\t// --padding-top\tTop padding of the input\n\t\t\t\t\t// --placeholder-color\tColor of the input placeholder text\n\t\t\t\t\t// --placeholder-font-style\tFont style of the input placeholder text\n\t\t\t\t\t// --placeholder-font-weight\tFont weight of the input placeholder text\n\t\t\t\t\t// --placeholder-opacity\tOpacity of the input placeholder text\n\n\t\t\t\t\t@extend %input;\n\n\n\t\t\t\t\t// }\n\n\t\t\t\t\t// &.input-field--poi {\n\t\t\t\t\t// \tcursor: pointer;\n\t\t\t\t\t// }\n\t\t\t\t}\n\n\t\t\t}\n\n            // Aggiunto da vigo\n            &.input-fields--time {\n              ngx-timepicker-field{\n                &.ri-field{\n                  width: 210px !important;\n                  padding-bottom: 2px !important;\n                  padding-top: 4px !important;\n                }\n                .input-fields.input-fields--text{\n                  gap: unset !important;\n                }\n              }\n              display: grid;\n              grid-template-columns: repeat(auto-fill, minmax(auto, 250px));\n              gap: unset;\n            }\n\t\t\t// Fine aggiunta Vigo\n\n\t\t\t&.input-fields--toggle {\n\t\t\t\tmargin: -10px -#{$page_px} 0;\n\t\t\t}\n\n\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-bottom: $mb;\n\t\t\t}\n\n\t\t}\n\n\t}\n\n\n\t&.page-3 {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(auto-fit, minmax(300px, auto));\n\t\tgap: 25px 40px;\n\n\t\t.col-bordered{\n      border-right: 1px solid var(--app-mid-lighter-2);\n    }\n\n    // Aggiunta Vigo\n    .info-lang{\n      grid-column: 1/-1;\n\n      a{\n        padding-left: 30px;\n        font-size: 14px;\n        cursor: pointer;\n        color: var(--app-main);\n      }\n    }\n    // Fine aggiunta Vigo\n\n\t\t.input-email {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t.input-field {\n\t\t\t\t@extend %input;\n\t\t\t\tmargin-right: 12px;\n\t\t\t}\n\n\t\t\t.btn-add {\n\t\t\t\tmargin: 0;\n\t\t\t\t--border-radius: 50%;\n\n\t\t\t\t$p: 8px;\n\t\t\t\t--padding-top: #{$p};\n\t\t\t\t--padding-bottom: #{$p};\n\t\t\t\t--padding-start: #{$p};\n\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\theight: auto;\n\n\t\t\t\tfont-size: 9px;\n\n\t\t\t\t// .btn-icon {}\n\t\t\t}\n\t\t}\n\n\t\t.emails {\n\t\t\tpadding-top: 10px;\n\n      // Aggiunta Vigo\n      ion-chip{\n        max-width: 90%;\n        ion-label{\n          max-width: calc(100% - 24px);\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n      // Fine aggiunta Vigo\n\n\n\t\t\t.email {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.text {\n\t\t\t\t\tmargin-top: -1px;\n\t\t\t\t\tmargin-right: 15px;\n\n\t\t\t\t\tcolor: var(--app-mid-dark);\n\n\t\t\t\t\t$lh: 20px;\n\t\t\t\t\tfont-size: 17px;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tfont-weight: 500;\n\n\t\t\t\t\tmax-height: calc(2 * #{$lh});\n\t\t\t\t\toverflow-y: hidden;\n\n\t\t\t\t\t// @extend %oneLiner;\n\t\t\t\t\t@extend %longWord;\n\t\t\t\t}\n\n\t\t\t\t.btn-close {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\t--border-radius: 50%;\n\n\t\t\t\t\t$p: 5px;\n\t\t\t\t\t--padding-top: #{$p};\n\t\t\t\t\t--padding-bottom: #{$p};\n\t\t\t\t\t--padding-start: #{$p};\n\t\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\t\theight: auto;\n\n\t\t\t\t\t// .btn-icon {}\n\t\t\t\t}\n\n\t\t\t}\n\n\t\t}\n\n\n\t\t.push-list {\n      margin: -8px -5px;\n\t\t\tpadding-top: 5px;\n\n\t\t\t.select-all {\n\t\t\t\tmargin-bottom: 7px;\n\t\t\t}\n\n      // Aggiunta Vigo\n      ion-chip{\n        max-width: 90%;\n        ion-label{\n          max-width: calc(100% - 48px);\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n      // Fine aggiunta Vigo\n\n\t\t}\n\n\t}\n\n\n\t&.page-4, &.page-5{\n\t\tpadding-top: 30px;\n\n\t\tdisplay: grid;\n\t\t// grid-template-columns: repeat(2, auto);\n\t\t// ? equivalent of (invalid) -> minmax(1fr, max-content)\n\t\tgrid-template-columns: repeat(2, minmax(0, auto)); // magic, see comment above\n\t\tgap: 12px 25px;\n\n\t\t// spacing of all elems relative to the container\n\t\tjustify-content: center;\n\t\t// align-content: flex-start;\n\t\t// min-height: 100%;\n\n\t\t// handle spacing inside elems\n    // align-items: center;\n\t\t// justify-items: center;\n\n\t\t@extend %longWord;\n\n\n\t\t.input-lbl {\n\t\t\tgrid-column: 1/3;\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\n\n\t\t$fz: 17px;\n\t\t$fw: 500;\n\n\t\t.output-lbl {\n\t\t\tcolor: var(--app-mid-light);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\n\t\t}\n\n\t\t.output-val {\n\t\t\tcolor: var(--app-mid-dark);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\n\t\t\t@extend %longWord;\n\n            a{\n              cursor: pointer;\n              margin: 0 5px;\n\n              &.und_ln{\n                text-decoration: underline;\n              }\n            }\n\t\t}\n\n        //Vigo\n        .u-btn {\n          margin: 0;\n          margin-left: 15px;\n\n          font-weight: 600;\n          text-transform: none;\n        }\n\n\t}\n\n\n\n}\n\n\n\n.pg-footer {\n\t@extend %modalFooter;\n}\n\n\n// Aggiunta Vigo\n.no_email{\n  color: var(--app-mid-light);\n}\n// Fine aggiunta Vigo\n\nion-input{\n  --padding-top: 12px;\n  --padding-bottom: 12px;\n  --padding-start: 12px;\n  --padding-end: 12px;\n}\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
